export const GENDERS = ["Male", "Female"];
